<template>
  <a target="_blank" href="https://go.bbva.com.ar/fgo/#/">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="26"
      height="26"
      viewBox="0 0 26 26"
    >
      <defs>
        <path id="a-go" d="M0 .493h7.987V9H0z" />
        <path id="c-go" d="M.11.492H10V9H.11z" />
      </defs>
      <g fill="none" fill-rule="evenodd">
        <circle cx="13" cy="13" r="13" fill="#5BBEFF" />
        <g transform="translate(4 8)">
          <mask id="b-go" fill="#fff">
            <use xlink:href="#a-go" />
          </mask>
          <path
            fill="#072046"
            d="M7.662 7.056L5.584 5.077l-1.3 1.237.9.857c-.227.06-.467.093-.715.093-1.461 0-2.645-1.127-2.645-2.518 0-1.39 1.184-2.518 2.645-2.518.926 0 1.74.454 2.212 1.14l1.306-1.243A4.544 4.544 0 0 0 4.469.493C2 .493-.001 2.397-.001 4.746 0 7.096 2.002 9 4.47 9c1.428 0 2.7-.64 3.518-1.633l-.326-.31v-.001z"
            mask="url(#b-go)"
          />
        </g>
        <g transform="translate(11 8)">
          <mask id="d-go" fill="#fff">
            <use xlink:href="#c-go" />
          </mask>
          <path
            fill="#072046"
            d="M5.943 2.228c-1.34 0-2.425 1.127-2.425 2.518 0 1.391 1.085 2.518 2.425 2.518 1.34 0 2.424-1.127 2.424-2.518 0-1.39-1.085-2.518-2.424-2.518M3.007 7.754L.111 4.746l2.896-3.008a3.99 3.99 0 0 1 5.793 0c1.6 1.662 1.6 4.355 0 6.016a3.99 3.99 0 0 1-5.793 0"
            mask="url(#d-go)"
          />
        </g>
      </g>
    </svg>
  </a>
</template>

<script>
export default {
  name: "GoImage"
};
</script>
<style scoped>
a:hover circle {
  fill: #fff;
}
</style>
